var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isPara && _vm.hasVtn
    ? _c(
        "div",
        { staticClass: "card-info" },
        [
          _c("el-row", [
            _c("div", { staticClass: "d-flex tb" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("p", { staticClass: "verde-text text-between" }, [
                    _vm._v(_vm._s(_vm.mensagem))
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _vm.hasVtn
                      ? _c(
                          "el-button",
                          {
                            staticClass: "green textButtonBreak",
                            attrs: { tipo: "success" },
                            on: {
                              click: function($event) {
                                return _vm.goLink()
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "center" }, [
                              _c("i", { staticClass: "fal fa-credit-card" }),
                              _vm._v("  " + _vm._s(_vm.mensagemBotao))
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b7243b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b7243b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/centralMensagens/AppAntecipacaoVtn.vue
// module id = null
// module chunks = 